import {Component, EventEmitter, Input, Output} from '@angular/core';
import {HttpClientService} from "../../../../core/services/http-client.service";
import {ToastService} from "../../../../core/services/toast.service";


@Component({
  selector: 'app-manage-address',
  templateUrl: './manage-address.component.html',
  styleUrl: './manage-address.component.css'
})
export class ManageAddressComponent {
   states: any;
  constructor(private http: HttpClientService,private toast: ToastService) {}
  @Input() defaultAddress: any;
  @Output() formData = new EventEmitter<any>();

  ngOnInit() {
    this.getStates();
  }

  saveData() {
    if (this.validateForm(this.defaultAddress)) {
      this.formData.emit(this.defaultAddress);
    }
  }

  private validateForm(formData): boolean {
    const arrayToCheck = Object.keys(formData);
    for (let key of arrayToCheck) {
      if (key != 'line2' && !formData[key]) {
        this.toast.error(`${key} is required`);
        return false;
      }
    }
    return true;
  }

  private getStates() {
    this.http.get(`store/stateList`)
      .subscribe((res) => {
        if (res.statusCode == 200) this.states = res.response;
      });
  }
}
